<template>
  <div class="order-item" @click="viewOrderDetail">
    <div class="order-detail">
      <div class="tag orange" v-if="order.status === 1">{{
        order.status_remark
      }}</div>
      <div
        class="tag blue"
        v-else-if="order.status === 2 || order.status === 3"
        >{{ order.status_remark }}</div
      >
      <div class="tag" v-else>{{ order.status_remark }}</div>
      <div
        class="qrcode"
        @click.stop="viewCouponCode"
        v-if="order.status === 2"
        >二维码</div
      >
      <div class="order-desc u-p-t-20">
        <div class="goods-detail">
          <div class="goods-img u-border"
            ><img :src="order.shop.logo"></div>
          <div class="goods-intro">
            <div class="name u-line-1">{{ order.shop.name }}</div>
            <div class="sports"
              >项目：{{ order.sport_order_item[0].category_name }}<br />场次：{{
                order.sport_order_item[0].cur_date
              }}
              {{ order.sport_order_item[0].session }}</div
            >
          </div>
        </div>
      </div>
      <div class="order-intro">
        <div class="order-time">下单时间：{{ order.created_at }}</div>
        <div class="intro"
          >订单总额：<span>{{ order.total_money }}</span></div
        >
      </div>
    </div>
  </div>
</template>

<script>
let flag = false

export default {
  props: {
    order: {
      type: Object
    }
  },
  data () {
    return {
      show: true,
      couponCode: false
    }
  },
  methods: {
    viewOrderDetail () {
      /* uni.navigateTo({
        url: `/pages/orderDetail/orderDetail?oid=${this.order.id}&status=0`
      }) */
      this.$router.push({ name: 'appletOrderDetails', query: { oid: this.order.id, status: 0 } })
    },
    async viewCouponCode () {
      this.$emit('view-code')
    },
    /* jumpRating () {
      uni.navigateTo({
        url: `/pages/ratings/rating?id=${this.order.id}`
      })
    }, */
    async payHandler () {
      await this.$u.throttle(this.submit, 1000)
    },

    async submit () {
      if (flag) {
        return false
      }
      flag = true
      const orderType = 'shop_coupon'
      const res = await this.$api.payHandler({ order_type: orderType, trade_id: this.order.id })
      if (res) {
        const { code, msg, data } = res
        if (code === 0) {
          this.$config.payHandler(
            { type: { order_type: orderType }, ...data, redirect: false, self: this },
            status => {
              if (status) {
                this.$config.orderTempMsgHandler('order')
                this.$emit('refresh')
              }
            },
            () => {
              setTimeout(() => {
                flag = false
              }, 1500)
            }
          )
        } else {
          this.$toast(msg)
          flag = false
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-item {
  margin: 0 .2rem;
  .order-detail {
    padding: .4rem .2rem 0;
    background-color: #fff;
    position: relative;
    .tag {
      position: absolute;
      font-size: .26rem;
      top: .4rem;
      right: .2rem;
      color: #818181;
      &.orange {
        color: #ff8100;
      }
      &.blue {
        color: #6cb2f9;
      }
    }
    .qrcode {
      position: absolute;
      right: .2rem;
      top: .9rem;
      text-align: center;
      color: #fff;
      font-size: .24rem;
      width: 1.4rem;
      line-height: .54rem;
      height: .54rem;
      background: #50acff;
      border-radius: .35rem;
    }
  }
  .goods-detail {
    display: flex;
    .goods-img {
      width: 1.4rem;
      height: 1.28rem;
      margin-right: .26rem;
      border-radius: .1rem;
      overflow: hidden;
    }
    .goods-intro {
      max-width: 4.2rem;
      .name {
        font-size: .3rem;
        color: #404040;
        font-weight: bold;
      }
      .sports {
        margin-top: .15rem;
        font-size: .26rem;
        color: #2d2d2d;
        line-height: .45rem;
      }
    }
  }
  .order-intro {
    height: .5rem;
    color: #4f4f4f;
    font-size: .26rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .order-time {
      color: #9c9c9c;
      font-size: .22rem;
    }
    .intro {
      color: #ff5151;
      span {
        font-weight: bold;
      }
    }
  }
}
</style>
